import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ApiService } from 'src/app/core/http/api.service';

@Injectable({
  providedIn: 'root',
})
export class PaidSupplierService {
  private paidSuppliers = new Set<string>([]);

  private isModalVisibleSubject = new BehaviorSubject<boolean>(false);
  isModalVisible$ = this.isModalVisibleSubject.asObservable();

  private launchGameSubject = new Subject<any>();
  launchGame$ = this.launchGameSubject.asObservable();

  private pendingGame: any;

  constructor(private readonly api: ApiService) {
    this.getPaidSuppliers();
  }

  private getPaidSuppliers() {
    this.api.get('lobby-open/paid-suppliers/', '').subscribe((res) => {
      if (res.data && res.data.length) {
        const paidSuppliers = res.data;
        const paidSuppliersIds = paidSuppliers.map(
          (paidSupplier: { id: string; commercialName: string }) =>
            paidSupplier.id
        );

        this.paidSuppliers = new Set(paidSuppliersIds);
      }
    });
  }

  checkBeforeLaunch(game: any) {
    if (!game?.gameVendorId) {
      this.launchGameSubject.next(game);
      return;
    }

    const isPaidSupplier = this.paidSuppliers.has(game.gameVendorId);

    if (isPaidSupplier) {
      this.pendingGame = game;
      this.isModalVisibleSubject.next(true);
    } else {
      this.launchGameSubject.next(game);
    }
  }

  confirmLaunch() {
    this.isModalVisibleSubject.next(false);
    if (this.pendingGame) {
      this.launchGameSubject.next(this.pendingGame);
      this.pendingGame = null;
    }
  }

  closeModal() {
    this.isModalVisibleSubject.next(false);
    if (this.pendingGame) {
      this.pendingGame = null;
    }
  }
}
